import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../../../_helpers/Helpers";
import * as actions from "../../../../../_redux/student-pre-interviews/StudentPreInterviewsAction";
import * as uiHelpers from "../InterviewsUIHelpers";
import { 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../../../_metronic/_partials/controls";
import { useInterviewsUIContext } from "../InterviewsUIContext";

export function InterviewsTable() {
  // Interviews UI Context
  const interviewsUIContext = useInterviewsUIContext();
  const interviewsUIProps = useMemo(() => {
    return {
      queryParams: interviewsUIContext.queryParams,
      setQueryParams: interviewsUIContext.setQueryParams,
      openEditInterviewModal: interviewsUIContext.openEditInterviewModal
    };
  }, [interviewsUIContext]);

  // Getting curret state of Student PreInterviews list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentPreInterviews }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);  
  
  // Student PreInterviews Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getInterviews(interviewsUIProps.queryParams));
    return () => dispatch(actions.cleanListState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interviewsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "personnel",
      text: "Personel",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "interviewTypeName",
      text: "Görüşme Türü",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "date",
      text: "Görüşme Tarihi",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "trackingDate",
      text: "Takip Tarihi",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "explanation",
      text: "Açıklama",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isEditionAuthorized,
      openEditInterviewModal: interviewsUIProps.openEditInterviewModal
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-0"
  }

  if (isEditionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: interviewsUIProps.queryParams.pageSize,
    page: interviewsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                interviewsUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}